import { useEffect } from "react";
import { useUpdateState } from "../utilities/utilities";
import { ZendeskSupportUrl } from "../utilities/constants";

export default function PasswordRecoveryHelp({
  onButtonClick,
  resendStatus,
  loading,
  dataQa,
  supportUrl = ZendeskSupportUrl,
  supportText = "Contact Support",
}) {
  let [state, update] = useUpdateState({ secondsRemaining: 0 });
  const { secondsRemaining } = state;

  useEffect(() => {
    if (!resendStatus?.codeSentAt) {
      update({ secondsRemaining: 0 });
      return;
    }
    const cooldownSecs = (resendStatus.resendCooldownMinutes || 2) * 60;
    const sentAt = new Date(resendStatus.codeSentAt).getTime();
    const tick = () => {
      const elapsed = Math.floor((Date.now() - sentAt) / 1000);
      update({ secondsRemaining: Math.max(0, cooldownSecs - elapsed) });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [resendStatus]);

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
  };

  const onCooldown = secondsRemaining > 0;
  const disabled = loading || onCooldown;
  const label = loading
    ? "Resending..."
    : onCooldown
    ? `Resend in ${formatTime(secondsRemaining)}`
    : "Resend";

  return (
    <div className="verification-inbox verification-resend-section">
      <p className="resend-inline">
        Didn&rsquo;t receive a code?
        <button
          type="button"
          className="resend-inline-button"
          onClick={onButtonClick}
          disabled={disabled}
          data-qa={dataQa}
        >
          {label}
        </button>
      </p>

      <a
        className="support-link"
        href={supportUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {supportText}
      </a>
    </div>
  );
}
